<template>
  <div class="template-oficial-container">
    <b-row
      align-h="end"
      align-v="center"
      class="mb-1"
    >
      <b-col md="3">
        <b-button
          v-ripple.400="'rgba(40, 199, 111, 0.15)'"
          variant="flat-primary"
          size="sm"
          :disabled="loadSync"
          @click="sincronizarTemplates"
        >
          <b-spinner
            v-if="loadSync"
            small
            class="mr-50"
          />
          <feather-icon
            v-else
            icon="RefreshCcwIcon"
            size="16"
            class="mr-50"
          />
          Sincronizar Templates
        </b-button>
      </b-col>
      <b-col md="4">
        <b-form-input
          id="filter-input"
          v-model="filter"
          type="search"
          size="sm"
          placeholder="Pesquisar"
          debounce="300"
        />
      </b-col>
    </b-row>
    <div class="table-wrapper">
      <b-table
        ref="selectableTable"
        selectable
        select-mode="single"
        :items="items"
        :fields="fields"
        :filter="filter"
        responsive="sm"
        :per-page="perPage"
        :current-page="currentPage"
        @row-selected="onRowSelected"
        @filtered="onFiltered"
      >
        <!-- Example scoped slot for select state illustrative purposes -->
        <template #cell(selected)="{ rowSelected }">
          <template v-if="rowSelected">
            <i class="feather icon-disc primary" />
          </template>

          <template v-else>
            <i class="feather icon-circle" />
          </template>
        </template>
        <template #cell(acoes)="data">
          <feather-icon
            icon="EyeIcon"
            size="18"
            class="ml-1 cursor-pointer color-icon"
            @click="viewTemplateWhats(data.item.conteudo)"
          />
        </template>
      </b-table>
    </div>
    <b-pagination
      v-model="currentPage"
      :total-rows="totalRows"
      :per-page="perPage"
      align="center"
      size="md"
      class="my-0"
    />
    <b-modal
      ref="openModalTemplate"
      title="Template Whatsapp"
      ok-only
      size="lg"
    >
      <div v-html="templateWhatsapp" />
    </b-modal>
  </div>
</template>

<script>
import {
  BTable,
  BFormInput,
  BRow,
  BCol,
  BPagination,
  BButton,
  BSpinner,
  VBTooltip,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import axios from '../../../../../axios-auth'

export default {
  components: {
    BTable,
    BFormInput,
    BRow,
    BCol,
    BPagination,
    BButton,
    BSpinner,
  },
  directives: {
    Ripple,
    'b-tooltip': VBTooltip,
  },
  data() {
    return {
      // selectedCheck: false,
      modes: ['multi', 'single', 'range'],
      fields: ['selected', 'id', 'nome', 'categoria', 'status', 'acoes'],
      items: [],
      status: [{
        1: 'Current', 2: 'Professional', 3: 'Rejected', 4: 'Resigned', 5: 'Applied',
      },
      {
        1: 'light-primary', 2: 'light-success', 3: 'light-danger', 4: 'light-warning', 5: 'light-info',
      }],
      selectMode: 'multi',
      selected: [],
      filter: null,
      totalRows: 1,
      currentPage: 1,
      perPage: 20,
      templateWhatsapp: '',
      loadSync: false,
    }
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    filter(newFilter) {
      this.fetchData() // Recarrega os dados quando o filtro muda
    },
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      axios.get('/api/v1/template_meta', {
        headers: {
          Authorization: 'Bearer '.concat(localStorage.getItem('token')),
          accept: 'application/json',
        },
      }).then(res => {
        // Filtra apenas templates ativos
        let tempItems = res.data.dados.filter(item => item.status === 'APPROVED' || item.status === 'ativo')

        // Filtragem adicional por texto (nome ou categoria), se houver filtro
        if (this.filter) {
          const filterLower = this.filter.toLowerCase()
          tempItems = tempItems.filter(item =>
            item.nome.toLowerCase().includes(filterLower)
            || item.categoria.toLowerCase().includes(filterLower))
        }

        this.items = tempItems.sort((a, b) => new Date(b.created_at || b.updated_at) - new Date(a.created_at || a.updated_at))
        this.totalRows = this.items.length
      }).catch(error => {
        this.$toast({
          component: 'b-toast',
          props: {
            title: 'Erro',
            variant: 'danger',
            solid: true,
          },
          content: `Erro ao buscar dados: ${error.message}`,
        })
      })
    },
    onRowSelected(items) {
      if (items.length > 0) {
        const selectedTemplateId = items[0].id
        // Emitindo o evento para o componente pai com o template_id selecionado
        this.$emit('update-template-id', selectedTemplateId)
      }

      if (localStorage.getItem('templateDiscador')) {
        localStorage.removeItem('templateDiscador')
      } else if (localStorage.getItem('templateEmail')) {
        localStorage.removeItem('templateEmail')
      } else if (localStorage.getItem('templateSms')) {
        localStorage.removeItem('templateSms')
      } else if (localStorage.getItem('templateManual')) {
        localStorage.removeItem('templateManual')
      }
      this.selected = items
    },
    selectAllRows() {
      this.$refs.selectableTable.selectAllRows()
    },
    clearSelected() {
      this.$refs.selectableTable.clearSelected()
    },
    selectThirdRow() {
      // Rows are indexed from 0, so the third row is index 2
      this.$refs.selectableTable.selectRow(2)
    },
    unselectThirdRow() {
      // Rows are indexed from 0, so the third row is index 2
      this.$refs.selectableTable.unselectRow(2)
    },
    onFiltered(filteredItems) {
      // Apenas atualiza a paginação. A filtragem principal é feita no fetchData.
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    viewTemplateWhats(template) {
      this.templateWhatsapp = ''
      this.templateWhatsapp = template
      this.$refs.openModalTemplate.show()
    },
    sincronizarTemplates() {
      this.loadSync = true
      axios
        .post('/api/v1/template_meta/sync', null, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
            accept: 'application/json',
          },
        })
        .then(res => {
          this.loadSync = false
          this.fetchData()
          const stats = res.data.dados
          this.$swal({
            title: 'Sincronização concluída!',
            html: `
              <p>Atualizados: <strong>${stats.updated}</strong></p>
              <p>Não encontrados: <strong>${stats.not_found}</strong></p>
              <p>Sem alteração: <strong>${stats.unchanged}</strong></p>
            `,
            icon: 'success',
            customClass: {
              confirmButton: 'btn btn-primary',
            },
          })
        })
        .catch(error => {
          this.loadSync = false
          this.$swal({
            title: 'Erro na sincronização',
            text: error.response?.data?.mensagem || 'Erro ao sincronizar templates.',
            icon: 'error',
            customClass: {
              confirmButton: 'btn btn-primary',
            },
          })
        })
    },
  },
}
</script>

<style lang="scss">
.template-oficial-container {
  min-height: 600px;
}

.table-wrapper {
  min-height: 500px;
}

.b-table-selectable{
  .feather{
    font-size: 1.3rem;
  }
}
</style>
